<template>
    <div>
        <div class="flex flex-row highcharts-compare">
            <div class="flex flex-column col-1">
                <div class="flex flex-column justify-content-end align-items-center h-3rem col-12">
                    <div class="flex spaced-2rem font-bold text-400">W(nm)</div>
                </div>
                <div class="flex flex-column justify-content-start align-items-center h-3rem col-12">
                    <div class="flex justify-content-center">
                        <span class="text-xl flex align-items-end font-bold">{{ currentTranssition() }}</span>
                        <span class="text-base flex align-items-center">{{ currentTranssition() ? 'nm' : '' }}</span>
                    </div>
                </div>
            </div>
            <div class="flex flex-column col-11">
                <div class="flex flex-row h-3rem">
                    <div v-for="n in generateRange(6)" class="flex justify-content-center align-items-end col-2"
                        :class="{ 'transsition': n > 2 }">
                        <span v-if="n === 1" class="spaced-2rem uppercase font-bold text-400">Filter</span>
                        <span v-if="n > 1" class="text-xl font-bold">{{ filterNameByIndex(n - 2) }}</span>
                    </div>
                </div>
                <div class="flex flex-row h-3rem wavelength">
                    <div v-for="n in generateRange(6)" class="flex justify-content-center align-items-center col-2"
                        :class="{ 'transsition': n > 2 }">
                        <span v-if="n === 1" class="spaced-2rem uppercase font-bold text-400">T(%)</span>
                        <span v-if="n > 1" class="text-xl font-bold" :style="{ 'color': filterColorByIndex(n - 2) }">
                            {{ getSeriesTransmission(filterNameByIndex(n - 2), '%') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useChartStore } from '@/stores/highcharts';
import { generateRange } from '@//utils/helpers';

const chartStore = useChartStore();

const currentTranssition = () => {
    return chartStore.currentWavelength;
};

const filterNameByIndex = (index) => {
    return chartStore.dataEnabled.length > index ? chartStore.dataEnabled[index] : '';
};

const filterColorByIndex = (index) => {
    return chartStore.dataArray.length > index ? chartStore.dataArray[index]['color'] : '';
};

const getSeriesWawelength = (filter, sufix = '') => {
    if (Object.keys(chartStore.seriesValues).includes(filter)) {
        return (chartStore.seriesValues[filter].w ? chartStore.seriesValues[filter].w : 0) + sufix;
    }
};
const getSeriesTransmission = (filter, sufix = '') => {
    if (Object.keys(chartStore.seriesValues).includes(filter)) {
        return (chartStore.seriesValues[filter].t ? chartStore.seriesValues[filter].t : 0) + sufix;
    }
};
</script>

<style scoped>
.transsition {
    border-left: .2rem solid #c1c1c1;
}

.wavelength {
    border-top: .2rem solid #c1c1c1;
}
</style>